import React from "react";

export function PageHeader({ title, subtitle, actions }) {
    return (
        <div
            className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6"
            data-testid="page-header"
        >
            <div>
                <h1 className="text-2xl font-semibold text-[#070F26]" data-testid="page-title">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-sm text-ntt-muted mt-1">{subtitle}</p>
                )}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
    );
}

export function StatusPill({ label, tone = "blue" }) {
    const map = {
        blue: "bg-[#DBEAF6] text-[#0072BC]",
        amber: "bg-[#FFC303] text-[#070F26]",
        gray: "bg-[#F4F6F9] text-ntt-muted border border-ntt-border",
        green: "bg-emerald-50 text-emerald-700 border border-emerald-200",
        red: "bg-red-50 text-red-700 border border-red-200",
    };
    return (
        <span
            className={`inline-flex items-center h-6 px-2 rounded text-[11px] font-medium ${map[tone] || map.gray}`}
        >
            {label}
        </span>
    );
}
